module.exports = __webpack_public_path__ + "media/images/nav/icon_14-03de9a7403b4fe4802f2e9c28d5fcdff.svg";